import React from "react";
import "./content-block.scss";

export default ({wrapper, children }) => (
  <div className={`${wrapper ? "content-wrapper": ""}`}>
    {children}
  </div>
);
